import React from "react";
import { Box, Chip, useTheme } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import CustomTypography from "../../common/form/CustomTypography";
import CircularProgressBar from "../../common/progressBars/CircularProgressBar";

interface CustomerHeadingProps {
  orderId: number;
  label: string;
  moduleName: string;
  brandName?: string;
  progressValue?: number;
  quantity?: number | null;
}

const CustomerHeading: React.FC<CustomerHeadingProps> = ({
  orderId,
  label,
  moduleName,
  brandName,
  progressValue,
  quantity,
}) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        pt: 0,
        width: "100%",
        borderRadius: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          [theme.breakpoints.down("sm")]: {
            display: "block",
            alignItems: "flex-start",
            gap: 1,
          },
        }}
      >
        <Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              flexWrap: "wrap",
            }}
          >
            <Box>
              <CustomTypography
                variant="heading4"
                fontWeight={700}
                color={theme.palette.customColors.greyTextColor}
              >
                #{orderId}
              </CustomTypography>
            </Box>

            <Box>
              {label && (
                <Box
                  sx={{
                    display: "inline-block",
                    maxWidth: "100%",
                    backgroundColor: "#e4e4e4", // default Chip background
                    borderRadius: "16px",
                    px: 1.5,
                    py: 0.2,
                    fontSize: "0.8rem",
                    fontWeight: 600,
                    wordBreak: "break-word",
                    whiteSpace: "normal",
                    overflowWrap: "break-word",
                  }}
                >
                  {label}
                </Box>
              )}
            </Box>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
            <CustomTypography variant="heading4" fontWeight={700}>
              {moduleName}
              {quantity && (
                <span
                  style={{ color: theme.palette.customColors.purple }}
                >{` (${quantity})`}</span>
              )}
            </CustomTypography>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            [theme.breakpoints.down("sm")]: {
              mt: 1,
              justifyContent: "center",
            },
          }}
        >
          {progressValue ? (
            <CircularProgressBar progress={progressValue} height={60} />
          ) : null}
        </Box>
      </Box>

      {brandName && (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 1 }}>
          <StarIcon
            sx={{
              color: theme.palette.customColors.purple,
              fontSize: "1rem",
            }}
          />
          <CustomTypography
            variant="heading7"
            fontWeight={600}
            color={theme.palette.customColors.greyTextColor}
          >
            {brandName}
          </CustomTypography>
        </Box>
      )}
    </Box>
  );
};

export default CustomerHeading;
